import { useConfigStore } from '@/store/useConfigStore';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const steps = [
  "Room & Window",
  "Style",
  "Fabric & Lining",
  "Preview",
  "Approval"
];

export function WizardProgress() {
  const currentStep = useConfigStore((state) => state.currentStep);

  return (
    <div className="w-full">
      {/* Desktop view */}
      <div className="hidden md:flex justify-between items-center w-full relative">
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-1 bg-slate-200 rounded-full z-0"></div>
        <div 
          className="absolute left-0 top-1/2 -translate-y-1/2 h-1 bg-amber-500 rounded-full z-0 transition-all duration-300"
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        ></div>
        
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          
          return (
            <div key={index} className="relative z-10 flex flex-col items-center gap-2">
              <div 
                className={cn(
                  "w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-colors shadow-sm",
                  isCompleted ? "bg-amber-500 text-white" : 
                  isCurrent ? "bg-slate-900 text-amber-400 ring-4 ring-amber-100" : 
                  "bg-white border-2 border-slate-300 text-slate-400"
                )}
              >
                {isCompleted ? <Check size={20} /> : index + 1}
              </div>
              <span className={cn(
                "text-sm font-medium absolute top-12 whitespace-nowrap",
                isCurrent ? "text-slate-900" : "text-slate-500"
              )}>
                {step}
              </span>
            </div>
          );
        })}
      </div>

      {/* Mobile view */}
      <div className="flex md:hidden flex-col items-center gap-3">
        <div className="flex justify-center gap-2 w-full">
          {steps.map((_, index) => (
            <div 
              key={index}
              className={cn(
                "h-2 rounded-full transition-all flex-1",
                index === currentStep ? "bg-amber-500" : 
                index < currentStep ? "bg-amber-500/50" : "bg-slate-200"
              )}
            />
          ))}
        </div>
        <div className="text-sm font-medium text-slate-700 flex items-center gap-2">
          {currentStep > 0 && <Check size={16} className="text-amber-500" />}
          <span>Step {currentStep + 1}: {steps[currentStep]}</span>
        </div>
      </div>
    </div>
  );
}
